import React from 'react';
import { Link } from 'react-router-dom';
import Section from '../ui/Section';
import SafeIcon from '../../common/SafeIcon';
import { FiArrowRight } from 'react-icons/fi';

const ProjectCard = ({ id, title, type, status, image }) => (
  <Link to={`/project/${id}`} className="group block border border-transparent hover:border-brand-text/10 p-4 -m-4 transition-colors duration-300">
    <div className="relative aspect-[4/3] overflow-hidden mb-6 bg-brand-text/5 flex items-center justify-center border border-brand-text/10">
      {image ? (
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover grayscale opacity-80 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700 ease-out"
        />
      ) : (
        <div className="text-brand-text/20 flex flex-col items-center gap-3 group-hover:text-brand-text/40 transition-colors duration-500">
          <div className="font-mono text-4xl tracking-tighter">M13</div>
          <div className="font-mono text-[10px] uppercase tracking-widest border border-current px-3 py-1">Projektbild folgt</div>
        </div>
      )}
      <div className="absolute top-4 left-4 bg-brand-bg text-brand-text px-3 py-1 font-mono text-[10px] uppercase tracking-widest z-10">
        {status}
      </div>
    </div>
    <div className="flex justify-between items-start">
      <div>
        <h3 className="text-2xl md:text-3xl mb-2">{title}</h3>
        <p className="font-mono text-xs text-brand-text/50 uppercase tracking-widest">{type}</p>
      </div>
      <div className="w-12 h-12 border border-brand-text/20 flex items-center justify-center rounded-full group-hover:bg-brand-text group-hover:text-brand-bg transition-all duration-300 -rotate-45 group-hover:rotate-0">
        <SafeIcon icon={FiArrowRight} className="text-lg" />
      </div>
    </div>
  </Link>
);

const Portfolio = () => {
  // Referenzprojekt — laut Vorgabe (Stand 17.06.2026) nur noch Mittelring 13.
  const projects = [
    {
      id: "mittelring-13",
      title: "Mittelring 13, Leipzig",
      type: "Mehrfamilienhaus · 11 Einheiten · KfW 40",
      status: "Referenzprojekt",
      image: "/images/mittelring-hero.webp"
    }
  ];

  const handleScrollClick = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: "smooth" });
    }
  };

  return (
    <Section id="portfolio" className="border-b border-brand-text/10">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16 md:mb-24 gap-6">
        <div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl leading-[0.9] mb-4">
            SERIELL.<br/><span className="text-brand-text/40">SKALIERBAR.</span>
          </h2>
          <p className="font-inter text-brand-text/70 max-w-md">
            Die hier eingesetzte serielle Präzision nutzen wir eins zu eins auch für Ihr individuelles Eigenheim.
          </p>
        </div>
        <a
          href="#contact"
          onClick={(e) => handleScrollClick(e, 'contact')}
          className="font-mono text-xs uppercase tracking-widest border-b border-brand-text pb-1 hover:text-brand-text/50 hover:border-brand-text/50 transition-colors shrink-0 cursor-pointer"
        >
          Projekt anfragen
        </a>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-16">
        {projects.map(p => <ProjectCard key={p.id} {...p} />)}
      </div>
    </Section>
  );
};

export default Portfolio;
